"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactPortalTelemetryCompatibilityPatch = exports.reactPortalTelemetryCompatibilityPatchImplementation = void 0;
function reactPortalTelemetryCompatibilityPatchImplementation(collectPaths, element) {
    if (collectPaths) {
        try {
            return {
                "data-pxt-telemetry-path": collectPaths(element).getTelemetryPath(),
            };
        }
        catch (e) {
            // TODO - capture error log
        }
    }
    return {};
}
exports.reactPortalTelemetryCompatibilityPatchImplementation = reactPortalTelemetryCompatibilityPatchImplementation;
function reactPortalTelemetryCompatibilityPatch(element) {
    var _a;
    const collectPaths = (_a = window.PxtTelemetry) === null || _a === void 0 ? void 0 : _a.collectPaths;
    return reactPortalTelemetryCompatibilityPatchImplementation(collectPaths, element);
}
exports.reactPortalTelemetryCompatibilityPatch = reactPortalTelemetryCompatibilityPatch;
